import { observer } from 'mobx-react-lite';

import { useFirstOpenTracking } from './useFirstOpenTracking';
import { useFirstVisitAddressModal } from './useFirstVisitAddressModal';
import { useJivoMobileButtonVisibility } from './useJivoMobileButtonVisibility';
import { useRequestCycle } from './useRequestCycle';
import { useRN } from './useRN';

export default observer(() => {
  useRN();
  useRequestCycle();
  useFirstOpenTracking();
  useFirstVisitAddressModal();
  useJivoMobileButtonVisibility();

  return null;
});
